import React from 'react'
import LoadingBar from 'react-top-loading-bar'
import Navbar from './components/Template/Navbar'
import About from './components/Template/About'
import Contact from './components/Template/Contact'
import Blog from './components/Template/Blog'
import Projects from './components/Template/Projects'
import Home from './components/Template/Home'
import FacebookLogin from './components/Template/FacebookLogin'
import TermsCon from './components/Template/TermsCon'
import PrivacyPol from './components/Template/PrivacyPol'
import Phishing from './components/Template/Blog/Phishing'
import Pyscript from './components/Template/Blog/Pyscript'
import PyHTMLNode from './components/Template/Blog/HTMLnode'
import chromeDinogame from "./components/Template/Blog/ChromeDino"
import pysms from "./components/Template/Blog/Waunsms"
import TemperatureWebsite from './components/Template/Blog/TemperatureWebsite'
import MouseClick from './components/Template/Blog/MouseClick'
import BirthdayWebsite from './components/Template/Blog/BirthdayWebsite'
import Adstxt from './components/Template/Blog/Adstxt'
import MatrixWebsite from './components/Template/Blog/MatrixWebsite'
import Memz from './components/Template/Blog/Memztrozen'
import VMBox from "./components/Template/Blog/VmBox"
import Projects2 from './components/Template/Projects2'
import BadRequestPage from './components/Template/BadRequestPage'
import Projects3 from './components/Template/Projects3'
import myCv from './components/Template/myCv'
import { useState } from 'react'



import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";


export default function App() {
    const [progress, setProgress] = useState(0)
    return (
        <Router>
            <LoadingBar
                color='#f11946'
                progress={progress}
                height={2}
            />
            <div>
                <Navbar />
                <Switch>
                    <Route exact path="/"><Home setProgress={setProgress} /></Route>
                    <Route exact path="/Projects"><Projects setProgress={setProgress} /></Route>
                    <Route exact path="/Blog"><Blog setProgress={setProgress} /></Route>
                    <Route exact path="/Contact"><Contact setProgress={setProgress} /></Route>
                    <Route exact path="/About"><About setProgress={setProgress} /></Route>
                    <Route exact path="/Login-Page"><FacebookLogin /></Route>
                    <Route exact path="/Terms-And-Conditions"><TermsCon /></Route>
                    <Route exact path="/Privacy-Policy"><PrivacyPol /></Route>
                    <Route exact path="/Projects/Page-2"><Projects2 /></Route>
                    <Route exact path="/Projects/Page-3"><Projects3 /></Route>
                    <Route path="/Blog/Phishing" component={Phishing} />
                    <Route path="/Blog/Pyscript" component={Pyscript} />
                    <Route path="/Blog/HTMLrender" component={PyHTMLNode} />
                    <Route path="/Blog/ChromeDinoHack" component={chromeDinogame} />
                    <Route path="/Blog/Python-Unlimited-SMS" component={pysms} />
                    <Route path="/Blog/Temperature-Calculate-Website" component={TemperatureWebsite} />
                    <Route path="/Blog/Mouse-RightClick-Disable" component={MouseClick} />
                    <Route path="/Blog/Birthday-Website" component={BirthdayWebsite} />
                    <Route path="/Blog/Ads-txt-error" component={Adstxt} />
                    <Route path="/Blog/Matrix-Website" component={MatrixWebsite} />
                    <Route path="/Blog/Memz-Virus" component={Memz} />
                    <Route path="/Blog/VM-Box-Tutorial" component={VMBox} />
                    <Route path="/About/MyCV" component={myCv} />
                    <Route path="*" component={BadRequestPage} />
                </Switch>
            </div>
        </Router>
    )
}
